module.exports = __webpack_public_path__ + "e77b44bbc199292bfb5d6651652fbda6.png";